import { Skeleton } from '@dbrain/ui';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useMicrosoft365Admin } from '../../../api/microsoft365-admin.js';
import { ErrorAlert } from '../../ErrorAlert.js';
import { productsKey, SETUP_PATH, setupStatus, SUMMARY_PATH } from './model.js';
import { BuiltinTile, StatusPill } from './parts.js';

/**
 * Yönetim › Entegrasyonlar for the firm's organization admins: "Hazır bağlantılar" above the firm's own
 * connections, with Microsoft 365's card. Not set up: "Kur" opens the setup; otherwise its state, how many people
 * are connected and "Yönet" for the summary.
 */
export function Microsoft365Overview() {
  const { t } = useTranslation();
  const titleId = useId();
  const admin = useMicrosoft365Admin();
  const dto = admin.data;
  const status = dto ? setupStatus(dto) : null;
  return (
    <section className="m365a-overview" aria-labelledby={titleId} data-testid="m365-overview">
      <div className="section-head">
        <h2 id={titleId} className="section-head__title">
          {t('microsoft365.admin.overview.title')}
        </h2>
        <span className="section-head__note">{t('microsoft365.admin.overview.hint')}</span>
      </div>
      <ErrorAlert error={admin.error} />
      {admin.isPending ? <Skeleton block /> : null}
      {dto && status ? (
        <article className="admin-card m365a-card" data-testid="m365-admin-card" data-status={status}>
          <BuiltinTile />
          <div className="m365a-card__main">
            <div className="m365a-card__title">
              <h3>{t('microsoft365.admin.name')}</h3>
              <StatusPill status={status} />
            </div>
            <p className="m365a-card__lead">
              {t(`microsoft365.admin.products.${productsKey(dto.features)}`)} · {t('microsoft365.admin.readOnly')}
            </p>
            <p className="m365a-card__facts" data-testid="m365-admin-card-facts">
              {status === 'not_set_up'
                ? t('microsoft365.admin.overview.notSetUp')
                : `${t('microsoft365.admin.overview.connected', { count: dto.connectedCount })} · ${t(dto.enabled ? 'microsoft365.admin.overview.firmOn' : 'microsoft365.admin.overview.firmOff')}`}
            </p>
          </div>
          {status === 'not_set_up' ? (
            <Link className="ui-button ui-button--primary" to={SETUP_PATH} data-testid="m365-set-up">
              {t('microsoft365.admin.overview.setUp')}
            </Link>
          ) : (
            <Link className="ui-button ui-button--secondary" to={status === 'incomplete' ? `${SETUP_PATH}?step=2` : SUMMARY_PATH} data-testid="m365-manage">
              {t(status === 'incomplete' ? 'microsoft365.admin.overview.resume' : 'microsoft365.admin.overview.manage')}
            </Link>
          )}
        </article>
      ) : null}
    </section>
  );
}
